<template>
  <div
    class="text system-warranty"
    :class="{
      client: message.chatUserRole === 'Customer',
    }"
  >
    <div>
      <div class="content gpt-ql-editor">
        <div :ref="message.id"></div>
      </div>
      <button
        class="primary"
        :aria-label="$t('GPT.LAYOUT.INPUT_SN')"
        @click="createBotSettingMessage"
        v-if="typingCompleted"
      >
        {{ $t("GPT.LAYOUT.INPUT_SN") }}
      </button>
    </div>

    <div class="time" v-if="typingCompleted">
      {{ message.createAt | localTime }}
    </div>
  </div>
</template>

<script>
import Typed from "typed.js";
export default {
  name: "gpt-message-system-warranty",
  data() {
    return {
      typingCompleted: false,
    };
  },
  props: {
    message: {
      type: Object,
    },
  },
  mounted() {
    const el = this.message.content;
    if (this.checkTyped(this.message.id) && this.message.id !== "loading") {
      this.$refs[this.message.id].insertAdjacentHTML("beforeend", el);
      this.typingCompleted = true;
    } else {
      this.startTying(el);
    }
  },
  methods: {
    startTying(el) {
      const vm = this;
      new Typed(this.$refs[this.message.id], {
        strings: [el],
        showCursor: false,
        typeSpeed: 10,
        loop: false,
        onComplete: function () {
          vm.setTyped(vm.message.id);
          vm.typingCompleted = true;
        },
      });
    },
    checkTyped(id) {
      let data = localStorage.getItem("asus_chat_gpt_typed") || [];
      return data.includes(id);
    },
    setTyped(id) {
      let data = JSON.parse(localStorage.getItem("asus_chat_gpt_typed")) || [];
      data.push(id);
      localStorage.setItem("asus_chat_gpt_typed", JSON.stringify(data));
    },
    createBotSettingMessage() {
      this.$store.commit("gpt/setBotRender", {
        chatType: "Warranty and Policy",
        chatType2: "inquire-product-warranty-period",
        BotScope: "warranty", // 似乎無用 暫時寫死
      });
      this.$store.dispatch(
        "gpt/createBotSettingMessage",
        "ChatGPT_Warranty_SnNo_Input"
      );
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
@import "gpt.scss";
</style>
